module.exports = __webpack_public_path__ + "img/arrow-90deg-up.284fdae8.svg";